import React, { useEffect } from 'react'
import DigitalPpc from '../components/service/DigitalPpc'
import Navbar from '../common/Navbar'
import Footer from '../common/Footer'
import { useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet'

const DigitalMarketingPpc = () => {
  const location = useLocation();
  useEffect(() => {
    const { search } = location;
    if (!search) {
      window.scroll(0, 0);
    }
  }, []);
  return (
    <>
      <Helmet>
        <meta
          name="keywords"
          content="Social media marketing agency Chennai,
                  The best PPC agency in Chennai,
                  Top 10 PPC Marketing Agencies in Chennai,
                  PPC Company in Chennai,
                  PPC Agency in Chennai,
                  Pay-per-click Chennai,
                  Best PPC campaign marketing agency Chennai,
                  Best PPC Services in Chennai,
                  Best PPC Services in India,
                  best ppc agencies,
                  online advertising agency Chennai,
                  online advertising agency India,
                  Google Ads & PPC Keywords in Chennai,
                  Google Ads & PPC Keywords in India,
                  google ads agency in Chennai,
                  google ads agency in India,
                  google ads management Chennai,
                  google ads management India,
                  best ppc company in Chennai,
                  best ppc company in India,
                  pay per click services Chennai,
                  pay per click services India,
                  google ads campaign setup Chennai,
                  google ads campaign setup India,
                  google advertising for small business Chennai,
                  google advertising for small business India,
                  google adwords expert Chennai,
                  google adwords expert India"
        />
        <title>PPC Marketing Services | Pay-Per-Click Agency | SMS ZOO ZOO</title>
        <meta
          name="description"
          content="Run high-performing PPC campaigns with a leading PPC advertising agency. Get instant traffic, better conversions, and measurable advertising results."
        />
      </Helmet>
      <div>
        <Navbar />
        <DigitalPpc />
        <Footer />
      </div>
    </>

  )
}

export default DigitalMarketingPpc
